
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/runner/[runner]",
      function () {
        return require("private-next-pages/runner/[runner].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/runner/[runner]"])
      });
    }
  